import Cookies from 'js-cookie';
import { getAuthCookieOptions } from 'r3ui-lib';
import { navigateTo, useRuntimeConfig } from '#imports';

export type ApiFetchAuthContext = 'protected' | 'public';

export function handleUnauthorizedResponse(): void {
  const { public: publicConfig } = useRuntimeConfig();
  Cookies.remove(
    'auth_token',
    getAuthCookieOptions({
      origin: publicConfig.origin as string | undefined,
      authCookieDomain: publicConfig.authCookieDomain as string | undefined,
    })
  );
  navigateTo('/login', { external: true });
}

export function fatalErrorHandler(response: Response): void {
  if (response.status === 401) {
    handleUnauthorizedResponse();
  }
}

function createApiFetchClient(authContext: ApiFetchAuthContext) {
  const config = useRuntimeConfig();
  const locale = Cookies.get('i18n_redirected');
  const token = Cookies.get('auth_token');

  return $fetch.create({
    baseURL: `${config.public.apiUrl}`,
    headers: {
      'Accept-Language': locale,
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    } as {
      'Accept-Language': string;
      Accept: string;
      Authorization: string;
    },
    onResponseError({ response }) {
      if (authContext === 'protected' && response.status === 401) {
        handleUnauthorizedResponse();
      }
    },
  });
}

export async function apiFetch<T>(
  request: string,
  options?: Parameters<ReturnType<typeof createApiFetchClient>>[1] & {
    authContext?: ApiFetchAuthContext;
  }
) {
  const authContext = options?.authContext ?? 'protected';
  const client = createApiFetchClient(authContext);
  const { authContext: _authContext, ...fetchOptions } = options ?? {};
  return await client<T>(request, fetchOptions);
}

export function tableTransportOptions() {
  return {
    onUnauthorized: fatalErrorHandler,
    onError: (error: unknown) => {
      // eslint-disable-next-line no-console
      console.error('[table-error]', error);
    },
    notFound: 'error' as const,
  };
}
